import cleanedFilename from '~/util/cleanedFilename';

export default {
  PDF_LINK: `${cleanedFilename(__filename)}-pdf-link`,
  PDF_LINK_PROCESSING: `${cleanedFilename(__filename)}-pdf-link-verwerking`,
};
